// extracted by mini-css-extract-plugin
export default {"container":"style_container__MtdzL","children":"style_children__9rEkQ","title":"style_title__XV9PP","divider":"style_divider__srfYA","formFooter":"style_formFooter__ayx9S"};